<template>
    <div>
        <Panel :title="$t('Password Configuration')" :total-rows="allItems.length" :page="page" @change="setPage">
            <table id="passwordexpiryconfig_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Organisation') }}</th>
                        <th>{{ $t('Password Expiry Days') }}</th>
                        <th v-if="$store.hasRight('GLOBAL_SETTINGS')">{{ $t('Hashed Passwords') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="organisation in pageItems">
                        <td>{{ organisation.name }}</td>
                        <td>
                            <CicNumber
                                v-if="Object.keys(expires).includes(organisation.orgId.toString())"
                                :min="1"
                                :value="expires[organisation.orgId.toString()]"
                                @input="(val) => (expires[organisation.orgId.toString()] = val)"
                            />
                        </td>
                        <td v-if="$store.hasRight('GLOBAL_SETTINGS')">
                            <CicCheckbox
                                :enabled="!originalHashes.includes(organisation.orgId)"
                                :value="selected.includes(organisation.orgId)"
                                @input="handleSelected(organisation.orgId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
            <template #footer>
                <CicButton id="save_expiry" @click="saveItem">{{ $t('Save') }}</CicButton>
                <CicButton id="expires_button" @click="toggleAll">
                    {{ $t(showExpiries ? 'Show All' : 'Show Expiries Only') }}
                </CicButton>
                <CicButton v-if="$store.hasRight('GLOBAL_SETTINGS')" id="hashed_button" @click="toggleHashed">
                    {{ $t(showUnhashed ? 'Show All' : 'Show Unhashed Only') }}
                </CicButton>
            </template>
        </Panel>

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import { pick } from 'lodash';
    import CicButton from '@/components/CicButton';
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicNumber from '@/components/inputs/CicNumber';
    import TableUtils from '@/mixins/TableUtils';
    import { load, save } from '@/utils/Http';

    export default {
        name: 'PasswordConfiguration',
        components: {
            CicButton,
            CicCheckbox,
            CicNumber,
            Panel,
        },
        mixins: [TableUtils],
        data() {
            return {
                expires: {},
                item: null,
                organisations: [],
                originalExpires: {},
                originalHashes: [],
                page: 1,
                selected: [],
                showExpiries: true,
                showUnhashed: false,
            };
        },
        computed: {
            allItems() {
                let orgs = this.organisations;
                if (this.showUnhashed) {
                    orgs = orgs.filter((org) => !this.originalHashes.includes(org.orgId));
                } else if (this.showExpiries) {
                    orgs = orgs.filter((org) => Object.keys(this.originalExpires).includes(org.orgId.toString()));
                }

                return orgs;
            },
            pageItems() {
                return this.allItems.slice((this.page - 1) * 20, this.page * 20);
            },
        },
        created() {
            this.loadTable();
        },
        methods: {
            loadTable() {
                load('passwordexpiry/get', {}, (response) => {
                    this.organisations = response.organisations;
                    this.originalExpires = response.expires;
                    this.expires = { ...this.originalExpires };
                    this.originalHashes = response.hashes;
                    this.selected = [...this.originalHashes];
                });
            },

            saveItem() {
                const expires = pick(
                    this.expires,
                    Object.keys(this.expires).filter((orgId) => this.expires[orgId] !== this.originalExpires[orgId]),
                );
                const hashes = this.selected.filter((orgId) => !this.originalHashes.includes(orgId));
                const params = { expires: JSON.stringify(expires), hashes: JSON.stringify(hashes) };
                save('passwordexpiry/update', params, () => {
                    this.loadTable();
                });
            },

            toggleAll() {
                this.page = 1;
                this.showUnhashed = false;
                this.showExpiries = !this.showExpiries;
            },

            toggleHashed() {
                this.page = 1;
                this.showExpiries = false;
                this.showUnhashed = !this.showUnhashed;
            },
        },
    };
</script>
